import { APP_URL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';

function LaunchSection() {
    const { t } = useLanguage();
    const tiles = [
        { href: APP_URL, cls: 'c-red', icon: '✦', title: t.navPackets, desc: t.tilePacketsDesc, go: t.tileOpen },
        { href: APP_URL, cls: 'c-sky', icon: '▣', title: t.navShopTravel, desc: t.tileShopDesc, go: t.tileExplore },
        { href: '#rewards', cls: 'c-gold', icon: '↗', title: t.tileCashbackTitle, desc: t.tileCashbackDesc, go: t.tileLearn },
        { href: APP_URL, cls: 'c-violet', icon: '◎', title: t.ddCircles, desc: t.tileCirclesDesc, go: t.tileSeePackets },
        { href: '#roadmap', cls: 'c-mint', icon: '⌁', title: t.roadmapStockTitle, desc: t.roadmapStockDesc, go: t.comingSoon },
        { href: '#advanced', cls: 'c-cyan', icon: '⌁', title: t.advancedMarketsTitle, desc: t.advancedMarketsDesc, go: t.comingSoon },
    ];

    return (
        <section className="launch" style={{ marginTop: 0 }} aria-labelledby="launchTitle">
            <div className="wrap">
                <div className="launch-head rv">
                    <h2 id="launchTitle">{t.launchTitle}</h2>
                    <p>{t.launchLead}</p>
                </div>
                <div className="tiles">
                    {tiles.map((tile, index) => (
                        <a
                            key={tile.title}
                            className={`ftile rv ${tile.cls}`}
                            href={tile.href}
                            style={{ '--rv-delay': `${index * 60}ms` }}
                        >
                            <span className="fi">{tile.icon}</span>
                            <b>{tile.title}</b>
                            <small>{tile.desc}</small>
                            <span className="go">{tile.go}</span>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default LaunchSection;
